import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rescoreVettingApplication } from '../services/vettingApplications';
import { vettingApplicationQueryKeys } from './query-keys';

export const useRescoreVettingApplicationMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ applicationId }) => {
      const result = await rescoreVettingApplication(applicationId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to trigger rescore');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: vettingApplicationQueryKeys.all });
      await queryClient.invalidateQueries({
        queryKey: vettingApplicationQueryKeys.detail(variables?.applicationId),
      });
      await onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};
